var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9V8.35116C2 7.85556 2.19838 7.38024 2.55149 7.0298C2.90461 6.67936 3.38354 6.4825 3.88291 6.4825L20.9207 2.08984C21.3902 1.96138 21.8871 1.97086 22.3513 2.11712C22.8155 2.26339 23.227 2.54017 23.5358 2.91388C24 3.51081 24 4.1337 24 5.18482V6.4825",
    stroke: "#B053EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0521 6.5H3.9479C2.87211 6.5 2 7.39674 2 8.50291V23.6221C2 24.7283 2.87211 25.625 3.9479 25.625H27.0521C28.1279 25.625 29 24.7283 29 23.6221V8.50291C29 7.39674 28.1279 6.5 27.0521 6.5Z",
    stroke: "#B053EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.75C20.6213 17.75 21.125 17.2463 21.125 16.625C21.125 16.0037 20.6213 15.5 20 15.5C19.3787 15.5 18.875 16.0037 18.875 16.625C18.875 17.2463 19.3787 17.75 20 17.75Z",
    fill: "#E7006E",
    stroke: "#B053EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ba15789ab30a338976318b8a90de7f2b.svg";
export { ForwardRef as ReactComponent };